var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIcQnaOn = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 34,
  height: 34,
  fill: "none"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#ic-qna-on_svg__a)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 17,
  cy: 17,
  r: 17,
  fill: "#fff"
}), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#ic-qna-on_svg__b)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#8268D9",
  d: "M11.098 19.974v-.713a.42.42 0 0 1 .418-.418h.909c.283 0 .492-.28.397-.546a3 3 0 0 1-.151-.63.415.415 0 0 0-.414-.374h-.741a.42.42 0 0 1-.418-.419v-.713a.42.42 0 0 1 .418-.418h.713a.42.42 0 0 0 .419-.419v-2.26a.42.42 0 0 0-.419-.419H9.97A1.974 1.974 0 0 0 8 14.613v7.327c0 .741.527 1.364 1.225 1.515.19.042.325.212.325.407v1.717c0 .372.45.56.713.295l2.261-2.26a.42.42 0 0 1 .296-.124h5.604a1.974 1.974 0 0 0 1.969-1.968v-.713a.42.42 0 0 0-.419-.419h-8.458a.42.42 0 0 1-.418-.418z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#C9BBF6",
  d: "M24.673 8h-8.558a1.92 1.92 0 0 0-1.917 1.917v7.009c0 1.055.862 1.917 1.917 1.917h5.675c.097 0 .19.04.26.107l2.36 2.36c.233.233.63.068.63-.26v-1.875c0-.172.119-.328.286-.36a1.555 1.555 0 0 0 1.262-1.522V9.917A1.92 1.92 0 0 0 24.671 8zm-1.55 7.745h-5.458a.37.37 0 0 1-.37-.37v-.81c0-.205.165-.37.37-.37h5.458c.205 0 .37.165.37.37v.81c0 .205-.165.37-.37.37m0-3.097h-5.458a.37.37 0 0 1-.37-.37v-.81c0-.205.165-.37.37-.37h5.458c.205 0 .37.165.37.37v.81c0 .205-.165.37-.37.37"
})))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "ic-qna-on_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h34v34H0z"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "ic-qna-on_svg__b"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M8 8h18.59v18H8z"
})))));
export default SvgIcQnaOn;